import Image from 'next/image';
import { Button } from '@/components';
import { SvgArrowMoreWhite } from '@/components/icons';
import { dateForFrontend } from '@/utils/dates';
import type { PromoCardProps } from './promoCard.types';
import s from './promoCard.module.scss';

const dateOpt: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit' };

export const PromoCard = ({ title, start, end }: PromoCardProps) => {
  const duration = `${dateForFrontend(start, dateOpt)} - ${dateForFrontend(end, dateOpt)}`;

  return (
    <div className={s.card}>
      <div>
        <div className={s.period}>{duration}</div>
        <p className={s.cardTitle}>{title}</p>
      </div>
      <div>
        <div className={s.imageWrapper}>
          <Image
            src="/promo.png"
            alt="Изображение для услуги"
            sizes="354px"
            fill
          />
        </div>
        <Button
          name="Подробнее"
          type="button"
          theme="primary"
          size="medium"
          rightIcon={<SvgArrowMoreWhite />}
        />
      </div>
    </div>
  );
};